// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__BD001","status":"styles_status__19KOD","icon":"styles_icon__20Oxt"};